import React, { useState, useEffect, useRef, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import ListSubheader from '@material-ui/core/ListSubheader';
import LocationOffOutlinedIcon from '@material-ui/icons/LocationOffOutlined';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';

import "../../styles/styles.css";
import { SummaryTabIndex, SummaryDBTabPanelIndex, MainTabPanelIndex, SummaryHistoryTabPanelIndex, 
  SummaryChatTabPanelIndex, SummaryLogsTabPanelIndex,
  CommonChat,
  AdminTabIndex,
  ControlLogTabPanelIndex, ControlAtlasPwdLogTabPanelIndex, ControlTabIndex, ControlDiagnosticTabPanelIndex,
  SummarySendToFtpServerInfoTabPanelIndex, 
  DetTunerTabIndex, DetTunerTabPanelIndex, BoardsTabPanelIndex,
  EquipsTabIndex, RegistryTabPanelIndex, ServiceTabPanelIndex,
  AdminRole, SEUserRole} from '../../model/constants';

import { AppContext } from '../../context/app-context';
import { AllEquipsContext } from '../../context/allEquips-context';
import { EventsContext } from '../../context/events-context';
import { CurrentEquipContext } from '../../context/currentEquip-context';
import { UsersContext } from '../../context/users-context';
import { CommunicationContext } from '../../context/communication-context';
import { ControlStateContext } from '../../context/controlState-context';
import { DetTunersContext } from '../../context/dettuners-context';
import {useSetCurrEquip} from '../../hooks/useSetCurrEquip'

import * as EquipWorker from '../../workers/equipWorker'
import * as AdminWorker from '../../workers/adminWorker'
import * as ControlWorker from '../../workers/controlWorker'
import * as DetTunerWorker from '../../workers/detTunerWorker'
// import * as WebSocket from '../../workers/webSocket'
import {sessionUid} from '../../utilities/utils'
import { useWebSocket } from '../../hooks/useWebSocket'
import { SettingsBackupRestore } from '@material-ui/icons';
import {getUSFullDate} from '../../utilities/utils'
import { useNavigate } from 'react-router-dom';
  
const drawerWidth = 240;
const drawerWidthSmall = 60;

const useStyles = makeStyles((theme) => ({
	appBar: {
		width: `calc(100% - ${drawerWidth}px)`,
		marginLeft: drawerWidth,
    [theme.breakpoints.down(600)]: {
			width: `calc(100% - ${drawerWidthSmall}px)`,
      marginLeft: drawerWidthSmall,
		}
	},
	formControl: {
		margin: theme.spacing(1),
		minWidth: 270,
	},
	tabControl: {
		margin: theme.spacing(1),
		minWidth: 950,
		width: "fill-content",
	},
	selectEmpty: {
		// marginTop: theme.spacing(2),
		color: "white",
    display: "flex",
    minHeight: "40px",
	},
	optionStyle: {
		backgroundColor: "#3f51b5",
    color: "white",
    minHeight: "54px",
	},
	userName: {
		// textAlign: "end",
		width: `calc(100% - 180px)`,
	},
	button: {
		marginRight: "0.5em",
		width: "30%",
	},
}));

export default function MainToolBar() {
  console.log(`! render MainToolBar ` + sessionUid);

  const classes = useStyles();
  const [appState, appDispatch] = useContext(AppContext);
  const [allEquipsState, allEquipsDispatch] = useContext(AllEquipsContext);
  const [eventsState, eventsDispatch] = useContext(EventsContext);
  const [currEquipState, currEquipDispatch] = useContext(CurrentEquipContext);
  const [usersState, usersDispatch] = useContext(UsersContext);
  const [communicationState, communicationDispatch] = useContext(CommunicationContext);
  const [controlState, controlDispatch] = useContext(ControlStateContext);
  const [detTunersState, detTunersDispatch] = useContext(DetTunersContext);  
  
  // const [currEquip, setCurrEquip] = useState('none');
  const [userName, setUserName] = useState('');
  //const [tabIndex, setTabIndex] = useState(0);
  const setCurrEquip = useSetCurrEquip();

  const token = usersState.token;
  const handleEquipsChange = async (event) => {
    const select = event.target;
    if (select.value !== undefined) {
      const val = select.value;
      await onEquipChanged(val);
    }
  };

  
  const selectedTab = appState.currentTab?.tab ?? SummaryTabIndex;
  const selectedTabPanel = appState.currentTab?.panel ?? MainTabPanelIndex;

  const onEquipChanged = async equipInfo =>
  {
    setCurrEquip(equipInfo, 'SETEQUIPINFO');
    allEquipsDispatch({ type: 'ADDSELECTEDEQUIPS', payload: equipInfo }); 
    //getEvents(equipInfo);
    
    if(SummaryTabIndex === selectedTab && SummaryHistoryTabPanelIndex === selectedTabPanel){        
      getEvents(equipInfo);
    }
    else if(SummaryTabIndex === selectedTab && SummaryChatTabPanelIndex === selectedTabPanel){        
      getChats(equipInfo);
    }
    else if(SummaryTabIndex === selectedTab && SummaryDBTabPanelIndex === selectedTabPanel && equipInfo){
      getAllDBTables(equipInfo);
    }
  }

  const getEquipsRegistry = async () =>
  {
    const equipsRegistry = await EquipWorker.GetEquipsRegistry(token);
    allEquipsDispatch({ type: 'SETEQUIPSREGISTRY', payload: equipsRegistry }); 
  }

  const getEvents = async (equipInfo) =>
  {
    const endDate = new Date();
    const allEvents = await EquipWorker.SearchEquip(token, 'Events', equipInfo, getUSFullDate(endDate), getUSFullDate(endDate));
    eventsDispatch({ type: 'SETEVENTS', payload: allEvents }); 
  }

  const getLogs = async () =>
  {
    const logs = await AdminWorker.GetServerLogs(token);
    communicationDispatch({ type: 'SETLOGS', payload: logs }); 
  }

  const getAtlasPwdLogs = async () =>
    {
      const logs = await AdminWorker.GetAtlasPwdLogs(token);
      communicationDispatch({ type: 'SETATLASPWDLOGS', payload: logs }); 
    }

  const getDiagnostics = async () =>
  {
    const metrics = await ControlWorker.GetServerMetrics(token);
    controlDispatch({ type: 'SETDIAGNOSTIC', payload: metrics }); 
  }

  const getAllDBTables = async (equipInfo) =>
  {
    const allTables = await EquipWorker.GetAllTables(token, equipInfo);
    currEquipDispatch({ type: 'SETALLDBTABLES', payload: allTables }); 
  }

  const getChats = async (equipInfo) =>
  {
    const notes = await EquipWorker.GetCommunications(token, equipInfo);
    communicationDispatch({ 
      type: 'SETCHATS', 
      payload: notes 
    }); 
  }

  const getTuners = async () =>
  {
    const tuners = await DetTunerWorker.GetTuners(token);
    detTunersDispatch({ type: 'SETTUNERS', payload: tuners });
  }

  const getDetectors = async () =>
  {
    const detectors = await DetTunerWorker.GetDetectors(token);
    detTunersDispatch({ type: 'SETDETECTORS', payload: detectors });
  }

  useEffect(() => {
    (async () => {
      setUserName(usersState?.currentUser?.Surname);
    })();
  }, [usersState.currentUser]);


  const webSocket = useWebSocket(
    {
    }
  );

  const equipInfo = currEquipState.equipInfo;
  const navigate = useNavigate();

  const onTabIndexChange = async (event, newValue) => {
    if (EquipsTabIndex === selectedTab && MainTabPanelIndex === newValue)
    {
      navigate("/info/equip/main", {state: { tabIndex: selectedTab, panelIndex: newValue}}); 
    }
    else if(EquipsTabIndex === selectedTab && RegistryTabPanelIndex === newValue)
    {
      getEquipsRegistry();
      navigate("/info/equip/registry", {state: { tabIndex: selectedTab, panelIndex: newValue}}); 
    }
    else if(EquipsTabIndex === selectedTab && ServiceTabPanelIndex === newValue)
    {
      navigate("/info/equip/service", {state: { tabIndex: selectedTab, panelIndex: newValue}}); 
    }
    else if(SummaryTabIndex === selectedTab && MainTabPanelIndex === newValue && equipInfo)
    {
      navigate("/info/summary/main", {state: { tabIndex: selectedTab, panelIndex: newValue}}); 
    }
    else if(SummaryTabIndex === selectedTab && SummaryDBTabPanelIndex === newValue && equipInfo)
    {
      getAllDBTables(equipInfo);
      navigate("/info/summary/BD", {state: { tabIndex: selectedTab, panelIndex: newValue }}); 
    }
    else if(SummaryTabIndex === selectedTab && SummaryHistoryTabPanelIndex === newValue)
    {        
      getEvents(equipInfo);
      navigate("/info/summary/history", {state: { tabIndex: selectedTab, panelIndex: newValue }});    
    }
    else if(SummaryTabIndex === selectedTab && SummaryChatTabPanelIndex === newValue)
    {        
      getChats(equipInfo);
      navigate("/info/summary/chat", {state: { tabIndex: selectedTab, panelIndex: newValue }});    
    }
    else if(SummaryTabIndex === selectedTab && SummarySendToFtpServerInfoTabPanelIndex === newValue)
    {        
      navigate("/info/summary/sendToFtp", {state: { tabIndex: selectedTab, panelIndex: newValue }});
    }
    else if(SummaryTabIndex === selectedTab && SummaryLogsTabPanelIndex === newValue)
    {        
      navigate("/info/summary/logs", {state: { tabIndex: selectedTab, panelIndex: newValue }});
    }
    else if(ControlTabIndex === selectedTab && MainTabPanelIndex === newValue)
    {        
      navigate("/info/control/main", {state: { tabIndex: selectedTab, panelIndex: newValue }});
    } 
    else if(ControlTabIndex === selectedTab && ControlLogTabPanelIndex === newValue)
    {        
      getLogs();
      navigate("/info/control/log", {state: { tabIndex: selectedTab, panelIndex: newValue }});
    } 
    else if(ControlTabIndex === selectedTab && ControlAtlasPwdLogTabPanelIndex === newValue)
    {        
      getAtlasPwdLogs();
      navigate("/info/control/atlasPwdLog", {state: { tabIndex: selectedTab, panelIndex: newValue }});
    }
    else if(ControlTabIndex === selectedTab && ControlDiagnosticTabPanelIndex === newValue)
    {        
      getDiagnostics();
      navigate("/info/control/diagnostic", {state: { tabIndex: selectedTab, panelIndex: newValue }});
    }
    else if(DetTunerTabIndex === selectedTab && MainTabPanelIndex === newValue)
    {        
      getDetectors();
      navigate("/info/detTuner/detector", {state: { tabIndex: selectedTab, panelIndex: newValue }});
    }
    else if(DetTunerTabIndex === selectedTab && DetTunerTabPanelIndex === newValue)
    {        
      getTuners();
      navigate("/info/detTuner/tuner", {state: { tabIndex: selectedTab, panelIndex: newValue }});
    }
    else if(DetTunerTabIndex === selectedTab && BoardsTabPanelIndex === newValue)
    {        
      navigate("/info/detTuner/boards", {state: { tabIndex: selectedTab, panelIndex: newValue }});
    }
    document.activeElement.blur();
   };

  const onUpdateDBInfo = async () =>{
    if(equipInfo){
      const res = await EquipWorker.UpdateDBInfo(token, equipInfo);
    }
  }

  const isDBInfoStateUpdating = currEquipState.remoteaccess?.DBInfoStateUpdating;
  const isValidSummaryTab = selectedTab === SummaryTabIndex && equipInfo;
  const isAdmin = usersState.currentUser?.Role === AdminRole;
  const isSEUser = usersState.currentUser?.Role === SEUserRole;
  return (
		<AppBar position="fixed" className={classes.appBar}>
			<Toolbar>
				<Typography variant="h6" noWrap></Typography>
				{selectedTab !== DetTunerTabIndex && selectedTab !== AdminTabIndex && !isSEUser ? (
					<FormControl className={classes.formControl}>
						<Select
							labelId="demo-simple-select-label"
							id="mainToolbarCombobox"
              value={currEquipState.equipInfo}
							onChange={handleEquipsChange}
							className={classes.selectEmpty}
							variant="outlined"
							inputProps={{ textOverflow: "ellipsis" }}>
							<ListSubheader className={classes.optionStyle}>Выбрано</ListSubheader>
							{currEquipState.equipInfo ? (
								<MenuItem value={currEquipState.equipInfo} className={classes.optionStyle}>
									<Typography variant="inherit">{currEquipState.equipInfo}</Typography>
								</MenuItem>
							) : null}
							<ListSubheader className={classes.optionStyle}>Активно</ListSubheader>
							{allEquipsState.connectedEquips?.map((i, ind) => (
								<MenuItem key={ind.toString()} value={i} className={classes.optionStyle}>
									<Typography variant="inherit">{i}</Typography>
								</MenuItem>
							))}
						</Select>
					</FormControl>
				) : null}
				<Tabs
					value={selectedTabPanel}
					onChange={onTabIndexChange}
					aria-label="simple tabs example"
					className={classes.tabControl}>
					{!isSEUser ? <Tab label={selectedTab == DetTunerTabIndex ? "Детекторы" : "Главная"} id="mainTabPanel" key="mainTabPanel" /> : <div/>}
					{isValidSummaryTab ? <Tab label="БД" id="dbTabPanel" key="dbTabPanel" /> : <div key="dbTabPanel"></div>}
					{isValidSummaryTab ? <Tab label="История" id="histTabPanel" key="histTabPanel" /> : <div></div>}
					{isValidSummaryTab ? <Tab label="Коммуникации" id="chatTabPanel" key="chatTabPanel" /> : <div></div>}
					{isValidSummaryTab ? <Tab label="Логи" id="logsTabPanel" key="logsTabPanel" /> : <div></div>}
					{isValidSummaryTab ? <Tab label="FTP" id="ftpTabPanel" key="ftpTabPanel" /> : <div></div>}
					{selectedTab === ControlTabIndex && isAdmin ? <Tab label="Диагностика" id="diagnosticTabPanel" key="diagnosticTabPanel" /> : <div></div>}
					{selectedTab === ControlTabIndex && isAdmin ? <Tab label="Логи сервера" id="logsTabPanel" key="logsTabPanel" /> : <div></div>}
          {selectedTab === ControlTabIndex && isAdmin ? <Tab label="Лог выдачи паролей" id="atlasPwdLogsTabPanel" key="atlasPwdLogsTabPanel" /> : <div></div>}
					{selectedTab === DetTunerTabIndex ? <Tab label="Тюнеры" id="detTunerTabPanel" key="detTunerTabPanel" /> : <div></div>}
					{selectedTab === DetTunerTabIndex ? <Tab label="Печатные платы" id="boardsTabPanel" key="boardsTabPanel" /> : <div></div>}
					{selectedTab === EquipsTabIndex && !isSEUser ? <Tab label="Реестр" id="registryTabPanel" key="registryTabPanel" /> : <div></div>}
          {selectedTab === EquipsTabIndex && (isSEUser || isAdmin) ? <Tab label="Сервис" id="serviceTabPanel" key="serviceTabPanel" /> : <div/>}
				</Tabs>
				{selectedTab === SummaryTabIndex ? (
					<Button
						variant="contained"
						color={isDBInfoStateUpdating ? "secondary" : "primary"}
						className={classes.button}
						onClick={onUpdateDBInfo}>
						{isDBInfoStateUpdating ? "Обновляется" : "Обновить"}
					</Button>
				) : (
					<></>
				)}
				<Typography variant="h6" noWrap align="right" className={classes.userName}>
					{userName}
				</Typography>
			</Toolbar>
		</AppBar>
	);
}